import React from 'react';
import logo from './logo.svg';
// import './css/main.css';
import { BrowserRouter, Route } from 'react-router-dom';

import NavBar from './NavBar.js';
import Home from './pages/Home.js';
import Feedback from './pages/Feedback.js';
import About from './pages/About.js';
import Profile from './pages/Profile.js';
import Hotels from './pages/Hotels.js';
import Footer from './Footer.js';

class App extends React.Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <NavBar />
            <Route path="/" exact component={Home} />
            <Route path="/home" exact component={Home} />
            <Route path="/about" exact component={About} />
            <Route path="/feedback" exact component={Feedback} />
            <Route path="/profile" exact component={Profile} />
            <Route path="/hotels" exact component={Hotels} />
          <Footer />
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
